import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { FiMessageCircle } from 'react-icons/fi'
import { useAuth } from '../contexts/authContext/index'
import AIChat from './AIChat'
import '../assets/styles/FloatingAssistantButton.css'

const FloatingAssistantButton = () => {
  const { currentUser } = useAuth()
  const location = useLocation()
  const [isOpen, setIsOpen] = useState(false)

  const isClient = currentUser?.photoURL === 'cliente'
  const isOnAssistantPage = location.pathname === '/ai-agent'

  useEffect(() => {
    if (isOnAssistantPage && isOpen) {
      setIsOpen(false)
    }
  }, [isOnAssistantPage, isOpen])

  if (!isClient) {
    return null
  }

  const toggleChat = () => {
    if (isOnAssistantPage) {
      return
    }
    setIsOpen((prev) => !prev)
  }

  const closeChat = () => setIsOpen(false)

  const buttonClasses = [
    'floating-ai-button',
    isOpen ? 'floating-ai-button--open' : '',
    isOnAssistantPage ? 'floating-ai-button--disabled' : '',
  ]
    .filter(Boolean)
    .join(' ')

  const buttonText = isOnAssistantPage
    ? 'Asistente en pagina'
    : isOpen
      ? 'Cerrar chat'
      : 'Habla con IA'

  const ariaLabel = isOnAssistantPage
    ? 'Asistente de IA abierto en la pagina'
    : isOpen
      ? 'Cerrar asistente de IA flotante'
      : 'Abrir asistente de IA flotante'

  return (
    <>
      {isOpen ? (
        <div className="floating-ai-chat">
          <div className="floating-ai-chat__panel">
            <AIChat variant="widget" onClose={closeChat} />
          </div>
        </div>
      ) : null}
      <button
        type="button"
        onClick={toggleChat}
        className={buttonClasses}
        aria-label={ariaLabel}
        aria-expanded={isOpen}
        disabled={isOnAssistantPage}
      >
        <FiMessageCircle className="floating-ai-button__icon" aria-hidden />
        <span className="floating-ai-button__label">{buttonText}</span>
      </button>
    </>
  )
}

export default FloatingAssistantButton

